import "./KeyService.module.css";
import Header from "@/reusable_sections/Header";
import SchlSselTechnologie from "./sections/SchlSselTechnologie";
import Roadmap from "./sections/Roadmap";
import Faq from "./sections/Faq";
import Pricing from "./sections/Pricing";
import Footer from "@/reusable_sections/Footer";
export default function KeyServicePage() {
  return <div>
      <Header />
      <SchlSselTechnologie />
      <Pricing />
      
      <Faq />
      <Footer />
    </div>;
}